import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import { PATHS } from "~/const/paths";

type Args = {
  /** キーワード上書き関数 */
  onOverWriteKeyword: (text: string) => void;
  /** 検索履歴非表示処理 */
  onHideSearch: () => void;
};

export const useEffectSearchFormState = (args: Args) => {
  const { onOverWriteKeyword, onHideSearch } = args;

  const { asPath } = useRouter();
  const isOnVodList = useMemo(() => asPath.startsWith(PATHS.VOD_LIST), [asPath]);

  const clearSearchFormState = () => {
    if (isOnVodList) return;
    onOverWriteKeyword("");
    onHideSearch();
  };
  useEffect(clearSearchFormState, [isOnVodList]);
};
